<style scoped></style>

<template>
  <div class="patient-form">
    <fm-form label-alone label-align="left" :inline="false">
      <fm-form-item label="药品">
        <fm-select placeholder="药品" clearable filterable v-model="newData.medicineTypeId">
          <fm-option v-for="item in medicineTypeList" :key="item.key" :label="item.label" :value="item.key"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="使用量">
        <fm-input-new type="number" v-model="newData.useOnce" placeholder="使用量"></fm-input-new>
      </fm-form-item>
      <fm-form-item label="单位">
        <fm-input-new v-model="newData.unit" placeholder="单位"></fm-input-new>
      </fm-form-item>
    </fm-form>
    <div style="display: flex;justify-content: center;height:50px;align-items: flex-end;">
      <fm-btn long @click="$emit('submit', newData)" style="margin-right: 2rem;">确定</fm-btn>
      <fm-btn long @click="$emit('close')">取消</fm-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: null }
  },
  created () {
    this.$store.dispatch('loadMedicineTypeList')
  },
  data () {
    return {
      newData: this.data ? JSON.parse(JSON.stringify(this.data)) : {}
    }
  },
  computed: {
    medicineTypeList () {
      return this.$store.getters.medicineTypeList
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.newData = this.data ? JSON.parse(JSON.stringify(this.data)) : {}
      }
    }
  }
}
</script>
